import React from 'react';
import Select from 'react-select';
import Translate from '@spordle/intl-elements';
import { useIntl } from 'react-intl';

import { translateApiProperty } from '@hisports/common';

import { useDivisions } from '../../queries/categories';
import { useLocale } from '../../i18n';

export default ({ name = 'divisionId', label = <Translate id="components.filters.division" />, filters, onSelect, ...props }) => {
  const { formatMessage } = useIntl();
  const [ locale ] = useLocale();
  const { data: options } = useDivisions();

  const value = filters[name]
  const getOptionLabel = option => translateApiProperty(option, 'name', locale);
  const getOptionValue = (option) => option.id
  const isOptionDisabled = (option, values) => false
  const isOptionSelected = (option, values) => values.some(value => option.id == value)
  const filterOption = (option, inputValue) => true
  const formatOptionlabel = (option, context) => {
    const division = typeof option == 'object' ? option : options?.find(division => division.id == option)
    if (!division) return;
    return getOptionLabel(division);
  }

  return <div className="filter filter-divisionId d-inline-block">
    <Select
      name={name}
      placeholder={label}
      value={[value]}
      isSearchable={false}
      isClearable
      onChange={(option, meta) => onSelect(option ? option.id : undefined, meta)}
      options={options}

      filterOption={filterOption}
      formatOptionLabel={formatOptionlabel}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      isOptionDisabled={isOptionDisabled}
      isOptionSelected={isOptionSelected}
      noOptionsMessage={() => formatMessage({ id: 'common.lang.no.options' })}

      {...props}
    />
  </div>
}
